import React from 'react';
import './ErrorMessage.css';

/**
 * 错误消息组件
 * @param {string} message - 错误消息文本
 * @param {Function} onRetry - 可选的重试回调函数
 * @param {string} type - 错误类型: 'error' | 'warning' | 'info'
 */
const ErrorMessage = ({ 
  message = '加载失败，请稍后重试', 
  onRetry, 
  type = 'error' 
}) => {
  return (
    <div className={`error-message-container ${type}`}>
      <div className="error-icon">
        {type === 'error' && (
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" fill="currentColor"/>
          </svg>
        )}
        {type === 'warning' && (
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" fill="currentColor"/>
          </svg>
        )}
        {type === 'info' && (
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" fill="currentColor"/>
          </svg>
        )}
      </div>
      <p className="error-text">{message}</p>
      {onRetry && (
        <button className="retry-button" onClick={onRetry}>
          重试
        </button>
      )}
    </div>
  );
};

export default ErrorMessage;
